<template>
  <div id="mainLayout">
    <loader></loader>
    <Navigation ref="navBar" />
    <div class="container-main container-fluid bd-layout p-0">
      <slot />
    </div>
    <section
      class="device-breakpoint"
    >
      <div
        class="content row justify-content-center h-100vh align-items-center"
      >
        <div class="col-12 col-lg-6 text-center py-5">
          <div class="mb-5 p-2">
            <img
              class="image" src="../assets/images/breakpoint-graphic.png"
            />
          </div>
          <div class="text-white">
            <h1 class="mb-3 text-white">
              This screen size is not supported yet.
            </h1>
            <p class="font-weight-semi-bold">
              Please switch to your laptop or desktop (or rotate your device if you are on a tablet) to use Sinchii.
            </p>
          </div>
          <div v-if="isLoggedIn" class="mt-2">
            <k-button variant="secondary" class="btn btn-lg btn-secondary w-100 mb-2" @click="logOut">
              Log Out
            </k-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import Navigation from "@/components/Navigation.vue" // @ is an alias to /src
  import Loader from "../components/Loader.vue";
  import AuthService from "@/services/auth-service";
  import store from "@/store";
  import eventBus from "@/eventBus";

  export default({
    name: "mainLayout",
    components: {
      Navigation,
      Loader
    },
    computed: {
      isLoggedIn() {
        return store.getters.isLoggedIn;
      }
    },
    methods: {
      toggleNavSettings() {
        this.$refs.navBar.toggleSettings();
      },
      async logOut() {
        eventBus.emit('close-all-popups');
        await AuthService.logout();
        this.$router.push("/login");
      }
    }
})
</script>
